<!--
	@author bluefirex
-->
<template>
	<div class="acquisit-index">
		<div>
			<transition name="logo-in-out" appear>
				<img src="/images/branding/logo_for_light.svg" alt="Acquisit Logo" />
			</transition>
			
			<ul v-if="isDev" :class="[{ visible: showLinks }]">
				<li><a href="https://github.com/visma-meglerfront/acquisit">GitHub</a></li>
				<li><a href="https://github.com/visma-meglerfront/acquisit-ui">AcquisitUI</a></li>
				<li>&copy; {{ new Date().getFullYear() }} Broker AS</li>
			</ul>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { onMounted, ref } from 'vue'
	
	const showLinks = ref<boolean>(false),
		isDev = import.meta.env.DEV
	
	onMounted(() => {
		if (import.meta.env.DEV) {
			setTimeout(_ => {
				showLinks.value = true
			}, 3000)
		} else {
			window.location.href = 'https://meglerfront.no'
		}
	})
</script>

<style lang="scss">
	@use '@/assets/mixins.scss' as m;
	
	.acquisit-index {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #fff;
		font-family: m.font(main);
		
		text-align: center;
		
		div {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			color: m.color("light-grey-blue");
			
			a {
				color: m.color("blue");
			}
			
			ul {
				display: flex;
				flex-direction: column;
				gap: 16px;
				
				list-style: none;
				padding: 0;
				opacity: 0;
				transition: opacity 0.3s;
				
				li {
					font-size: 1rem;
					margin: 0 5px;
				}
				
				a {
					color: m.color("blue");
				}
				
				&.visible {
					opacity: 1;
				}
			}
			
			img {
				height: 64px;
				margin-bottom: 32px;
			}
		}
		
		@include m.two-way-vue-transition('logo-in-out', 3s, cubic-bezier(0,.75,.65,1.31)) {
			0% {
				opacity: 0;
				transform: translateY(50%) scale(2.7) rotateZ(-8deg);
			}
			
			100% {
				opacity: 1;
			}
		}
	}
</style>